<template>
  <div class="issue-details">
    <h2 class="issue-details__title">{{ issue.title }}</h2>
    <p class="issue-details__id">ID: {{ issue.id }}</p>

    <span
      class="issue-details__status"
      :class="`issue-details__status--${issue.status.replace(/ /g,'').toLowerCase()}`"
    >
      {{ issue.status }}
    </span>

    <label class="issue-details__label">Date of issues</label>
    <p class="issue-details__date">{{ issue.post_date | tableDate }}</p>

    <label class="issue-details__label">Project</label>
    <p class="issue-details__project">{{ issue.project_name }}</p>

    <label class="issue-details__label">Name of developer</label>
    <div class="issue-details__person">
      <v-avatar
        size="32px"
        color="blue-light"
        class="issue-details__person-avatar"
      >
        <img
          v-if="issue.developer_avatar"
          alt="Avatar"
          :src="issue.developer_avatar"
        >
        <span v-else class="white--text">
          {{ nameInitials(issue.developer_name) }}
        </span>
      </v-avatar>
      <div class="issue-details__person-data">
        <div class="issue-details__person-name">{{ issue.developer_name }}</div>
        <div class="issue-details__person-details">
          {{ issue.developer_roles.join(', ') }}
        </div>
      </div>
    </div>

    <template v-if="issue.client_name">
      <label class="issue-details__label">Name of client</label>
      <div class="issue-details__person">
        <v-avatar
          class="issue-details__person-avatar"
          size="32px"
          color="blue-light"
        >
          <img
            v-if="issue.client_avatar"
            alt="Avatar"
            :src="issue.client_avatar"
          >
          <span v-else class="white--text">
            {{ nameInitials(issue.client_name) }}
          </span>
        </v-avatar>
        <div class="issue-details__person-data">
          <div class="issue-details__person-name">{{ issue.client_name }}</div>
          <div class="issue-details__person-details">{{ issue.client_company_name }}</div>
        </div>
      </div>
    </template>

    <template v-if="issue.hr_name">
      <label class="issue-details__label">Name of HR</label>
      <div class="issue-details__person">
        <v-avatar
          v-if="issue.hr_avatar"
          class="issue-details__person-avatar"
          size="32px"
          color="blue-light"
        >
          <img
            alt="Avatar"
            :src="issue.hr_avatar"
          >
        </v-avatar>
        <div class="issue-details__person-data">
          <div class="issue-details__person-name">{{ issue.hr_name }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },

  methods: {
    nameInitials(name) {
      return name.split(' ').map((n) => n[0]).join('').substr(0, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.issue-details {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 6px #00000029;

  &__title {
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    margin-bottom: 2px;
  }
  &__id {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
  }
  &__label {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 4px;
  }
  &__date {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  &__project {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  &__status {
    font-size: 14px;
    background: $color--green;
    border-radius: 4px;
    color: #fff;
    padding: 4px 16px;
    font-weight: 500;
    width: fit-content;
    margin-bottom: 16px;

    &--senttohr {
      background: $color--yellow;
    }
    &--completed {
      background: $color--green;
    }
    &--responded {
      background: $color--blue;
    }
  }
  &__person {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  &__person-avatar {
    border-radius: 32px;
    margin-right: 8px;
    font-size: 16px;
  }
  &__person-name {
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
  }
  &__person-details {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
